<template>
  <div>
    <Header />
    <Stepper />
    <div id="zip-modal">
      <div class="zip-modal-header">
        <h3 class="zip-modal-title">우편번호 검색</h3>
      </div>
      <VueDaumPostcode style="height: 100%;" @complete="completePostCode($event)" />
    </div>
    <div class="delivery section">
      <form @submit.prevent="submit">
        <div class="grid">
          <p class=""><span class="point-red">필수입력</span></p>
          <div class="grid-item phone-num">
              <dl class="input-list">
                <dt>
                  <label for="ex01">
                    <span class="essential">수령자</span>
                  </label>
                </dt>
                <dd>
                  <input type="text" id="ex01" name="receive-name" v-model="receive.name" class="input-default" v-validate="{required: true}" data-vv-validate-on="change|focus|keyup">
                </dd>
                <dt>
                  <label><span class="essential">배송지</span></label>
                </dt>
                <dd>
                  <div class="input-mix-button">
                    <input type="text" name="receive-address1" v-model="receive.address1" class="input-default disabled" disabled v-validate="{required: true}" data-vv-validate-on="change|focus|keyup">
                    <button type="button" class="button-border black width-100" @click="openPostcode">주소검색</button>
                  </div>
                  <input type="text" name="receive-address2" v-model="receive.address2" class="input-default" v-validate="{required: true}" data-vv-validate-on="change|focus|keyup">
                  <!-- <input type="hidden" name="receive-zonecode" v-model="receive.zonecode"> -->
                </dd>
                <dt>
                  <label><span class="essential">수신인 휴대폰 번호</span></label>
                </dt>
                <dd>
                  <div class="input-divide3">
                    <input type="number" name="receive-phone1" @keyup="phoneCheck($event)" v-model="receive.phone1" class="input-default" v-validate="{required: true, min: 3, max:3}" data-vv-validate-on="change|focus|keyup">
                    <input type="number" name="receive-phone2" @keyup="phoneCheck($event)" v-model="receive.phone2" class="input-default" v-validate="{required: true, min: 3, max:4}" data-vv-validate-on="change|focus|keyup">
                    <input type="number" name="receive-phone3" @keyup="phoneCheck($event)" v-model="receive.phone3" class="input-default" v-validate="{required: true, min: 4, max:4}" data-vv-validate-on="change|focus|keyup">
                  </div>
                </dd>
                <dd>
                  <!--<p class="on-error">숫자만 입력 가능합니다.</p>-->
                  <!-- <p class="on-error on">숫자만 입력 가능합니다.</p> -->
                </dd>
                <dt>
                  <label><span class="">배송요청사항</span></label>
                </dt>
                <dd>
                  <select name="receive-requested" :required="true" v-model="receive.requested">
                    <!-- <option value="" :selected="true">배송시 요청사항을 선택해 주세요</option> -->
                    <option :value="item.code" v-for="item in options" :key="item.code">{{item.name}}</option>
                  </select>
                </dd>
                <dd>
                  <textarea
                    name="receive-request-detail"
                    v-model="receive.requestDetail"
                    class="textarea-height90"
                    placeholder="배송시 요청 사항을 입력해 주세요."/>
                </dd>
              </dl>
          </div>
          <div class="buttn-area">
            <button type="button" class="button-full gray" v-if="errors.any() || beginErrorStatus">다음</button>
            <button type="submit" class="button-full blue" v-if="!errors.any() && !beginErrorStatus">다음</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/Header';
import Stepper from '@/components/Stepper';
import {VueDaumPostcode} from "vue-daum-postcode"
import axios from 'axios';

export default {
  name: "DeliverRegister",
  components: {
    Header,
    Stepper,
    VueDaumPostcode
  },

  data(){
    return {
      pin: this.$route.params.pin,
      img: this.$route.params.img,
      prdName: this.$route.params.prdNm,
      receive: {},
      beginErrorStatus : true,
      options: []
    }
  },
  activated() {
    localStorage.removeItem('receive');
  },
  created(){
    localStorage.removeItem('receive');
    // console.log(this.$route.params)
    // if(localStorage.receive !== undefined){
    //   const received = JSON.parse(localStorage.receive);
    //   this.receive.name = received.name;
    //   this.receive.address1 = received.address1;
    //   this.receive.address2 = received.address2;
    //   this.receive.zonecode = received.zonecode;
    //   this.receive.phone1 = received.phone1;
    //   this.receive.phone2 = received.phone2;
    //   this.receive.phone3 = received.phone3;
    //   this.receive.requested = received.requested;
    //   this.receive.requestDetail = received.requestDetail;
    //   this.beginErrorStatus = false;
    //   console.log(received);
    // }
    // else{
    //   this.receive.requested = '';
    //   console.log('received');
    // }

    axios.get(`${process.env.ENDPOINT_02}/common/codes?code_grp_no=X048`)
    .then(response => {
      if(response.status==200){
        let data = response.data;
        if(data.return_cd === '0000'){
          this.options = data.response.commonCodeList
          this.options.unshift({code:'',name: '배송시 요청사항을 선택해 주세요'})
          console.log(this.options)
        }
        else{
          console.log('cd error :', data.return_cd);
        }
      }
    })
    .catch(error => {
      console.log(error);
    });
  },
  methods: {
    submit(){
      localStorage.receive = JSON.stringify(this.receive);
      this.$router.push({ name: 'deliver-request',params: { pin: this.pin, img: this.img, prdNm: this.prdName }});
    },
    phoneCheck(e){
        if(this.beginErrorStatus===true) this.beginErrorStatus = false;
        let len = e.target.value.length;
        if(e.target.name==='receive-phone1'){
            if(len == 3){
                document.querySelector("input[name=receive-phone2]").focus();
            }
        }else if(e.target.name==='receive-phone2'){
            if(len == 4){
              document.querySelector("input[name=receive-phone3]").focus();
            }
        }else if(e.target.name==='receive-phone3'){
            if(len > 4){
              let phone3 = e.target;
              phone3.value = phone3.value.slice(0,4)
            }
        }
    },
    openPostcode(){
      document.getElementById('zip-modal').style.display="block";
      document.querySelector(".vue-daum-postcode-container").style.height=100+'%';
    },
    completePostCode(data){
      document.getElementById('zip-modal').style.display="none";

      let addr = '';
      let extraAddr = '';

      if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
          addr = data.roadAddress;
      } else { // 사용자가 지번 주소를 선택했을 경우(J)
          addr = data.jibunAddress;
      }
      // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
      if(data.userSelectedType === 'R'){
          if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
              extraAddr += data.bname;
          }
          if(data.buildingName !== '' && data.apartment === 'Y'){
              extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
          }
          if(extraAddr !== ''){
              extraAddr = '(' + extraAddr + ')';
          }
          // 조합된 참고항목을 해당 필드에 넣는다.
          this.receive.address2 = extraAddr;

      } else {
          this.receive.address2 = '';
      }
      // 우편번호와 주소 정보를 해당 필드에 넣는다.
      // document.getElementById('sample3_postcode').value = data.zonecode;
      this.receive.zonecode = data.zonecode;
      this.receive.address1 = addr;
      // 커서를 상세주소 필드로 이동한다.
      document.querySelector("input[name=receive-address2]").focus();
    }
  }
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/contents.scss';
input, textarea {
  -webkit-appearance: none;
  border-radius: 0;
}
select {
  border-radius: 0;
}
#zip-modal{
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: calc(100% - 35px);
  z-index: 10;
  .vue-daum-postcode {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
  }
  .zip-modal-header {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 35px;
    padding: 0 20px;
    background-color: #222;
    &::after,
    &::before {
      position: absolute;
      right: 25px;
      content: '';
      width: 1.5px;
      height: 15px;
      background-color: #fff;
    }
    &::after {
      transform: rotate(45deg);
    }
    &::before {
      transform: rotate(-45deg);
    }
    .zip-modal-title {
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DeliverRegister.vue